// components/InServiceList.js
import React, { useContext, useEffect, useState } from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime'; // Ícone de relógio
import { DataContext } from '../DataContext';
import { useDraggable, useDroppable } from "@dnd-kit/core";

const Timer = ({ elapsedTime }) => {
  // Separando os minutos e segundos
  const [minutes, seconds] = elapsedTime.split(':');

  // Converter o tempo para segundos
  const elapsedSeconds = parseInt(minutes) * 60 + parseInt(seconds);

  let backgroundColor = "#93bbd8"
  if (elapsedSeconds > 30 * 60) {
    backgroundColor = "#ef8383"
  }

  function formatMinutes(minutes) {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${hours>0 ? String(hours).padStart(2, '0')+':' : ''}${String(mins).padStart(2, '0')}`;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: backgroundColor,
        color: 'white',
        fontSize: '14px',
        padding: '8px ',
        borderRadius: '20px',
        fontWeight: '600',
        minWidth: '80px',
        transition: 'background-color 0.3s ease',
      }}
    >
      <IconButton sx={{ color: '#cee4f4', padding: 0, marginRight: 1 }}>
        <AccessTimeIcon />
      </IconButton>
      <Typography variant="body2" sx={{ display: 'inline-block' }}>
        {formatMinutes(minutes)}
      </Typography>
      <Typography
        variant="body2"
        sx={{
          display: 'inline-block',
          // fontSize: '12px',
          fontWeight: 'normal',
          color: '#cee4f4', // Cor mais clara para os segundos
        }}
      >
        :{seconds}
      </Typography>
    </Box>
  );
};

const InServiceList = ({ onDragEnd, onDragStart, onDrop, onDragOver }) => {
  const { data } = useContext(DataContext);
  const [elapsedTimes, setElapsedTimes] = useState({});

  const { setNodeRef } = useDroppable({
    id: "inService",
  });

  // Função para calcular o tempo decorrido
  const calculateElapsedTime = (startTime) => {
    const now = new Date();
    // Garante que o JavaScript interprete a data como UTC
    const start = new Date(startTime + 'Z'); 
    const elapsed = Math.floor((now - start) / 1000);
    const minutes = Math.floor(elapsed / 60).toString().padStart(2, '0');
    const seconds = (elapsed % 60).toString().padStart(2, '0');
    return `${minutes}:${seconds}`;
  };
  
  // Atualiza o tempo decorrido a cada segundo
  useEffect(() => {
    const interval = setInterval(() => {
      const updatedTimes = {};
      data.inService.forEach((item) => {
        updatedTimes[item.uuid] = calculateElapsedTime(item.status_at);
      });
      setElapsedTimes(updatedTimes);
    }, 1000);

    return () => clearInterval(interval);
  }, [data.inService]);

  return (
    <div
      className={`droppable inService section`}
      ref={setNodeRef}
      onDrop={(event) => onDrop(event, 'inService')}
    >
      <div className="categoryTitle">
        Atendendo <span className="categoryQuantity">({data.inService.length})</span>
      </div>
      <div className="card-container">
        {data.inService.map((item, index) => (
          <DraggableCard key={item.uuid} item={item} index={index} elapsedTimes={elapsedTimes} />
        ))}
      </div>
    </div>
  );
};


const DraggableCard = ({ item, index, elapsedTimes }) => {
  const S3_URL = process.env.REACT_APP_S3_URL;

  const { attributes, listeners, setNodeRef, transform } = useDraggable({
    id: item.uuid,
    data: { itemId: item.uuid, sourceCategory: "inService" },
  });

  const style = {
    transform: transform ? `translate(${transform.x}px, ${transform.y}px)` : undefined,
    touchAction: "none",
    position: "relative",
    zIndex: 1000,
  };

  return (
    <div ref={setNodeRef} className="card" style={style} {...listeners} {...attributes}>
      <div className="avatar">
        <img src={`${S3_URL}/img/user/${item.avatar_url}`} alt={item.name} className="avatar-img" />
        <span className="avatar-number">{index + 1}</span>
      </div>
      <div className="info">
        <span className="name-with-margin">{item.name}</span>
        <Timer elapsedTime={elapsedTimes[item.uuid] || '00:00'} />
      </div>
    </div>
  );
};

export default InServiceList;
